function check(password?: string) {
  if (!password) return false
  return /[a-z]/.test(password)
}

export default {
  check,
}
